import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { TfiEmail } from "react-icons/tfi";
import { useNavigate } from "react-router-dom";
import { deleteApi, getApi, postApi } from "../pages/AppApis";
import moment from "moment/moment";
import { toast } from "react-toastify";
import { TbHomeUp } from "react-icons/tb";
import { FaCheck } from "react-icons/fa";
import { MdOutlineReportProblem, MdSupportAgent } from "react-icons/md";

export default function NotificationPopup({ setIsNotificationPopupOpen }) {
    const [selectedTab, setSelectedTab] = useState("All");
    const navigate = useNavigate();

    const [notificationsDAta, setNotificationsDAta] = useState([]);

    useEffect(() => {
        getNotificationData();
    }, []);
    const getNotificationData = async () => {
        try {
            const response = await getApi("/notifications/user/notifications");
            if (response?.response?.data?.user_notifications) {
                setNotificationsDAta(response?.response?.data?.user_notifications);
            }
        } catch (error) {
            console.log("Error fetching notifications:", error);
        }
    };
    const onClickItem = async (link, item) => {
        markAsRead(item);
        if (item && item?.type === "message") {
            return await navigate(`/chat?chat_id=${item.metadata.conversation_id}`);
        }
        if (link.includes("verifyaccount")) {
            await navigate("/start-verification");
        } else if (link.includes("propertylist") || link.includes("properties")) {
            let property_id = link.split("/").pop();
            await navigate("/MyProperties", { state: { property_id: property_id } });
        } else if (link.includes("chat")) {
            await navigate("/chat");
        }
        setIsNotificationPopupOpen(false);
    };

    function formatDate(inputDate) {
        const now = moment();
        const date = moment(inputDate);

        if (date.isSame(now, "day")) {
            return `Today, ${date.format("hh:mm A")}`;
        } else if (date.isSame(now.subtract(1, "day"), "day")) {
            return `Yesterday, ${date.format("hh:mm A")}`;
        } else {
            return date.format("MMM DD, hh:mm A");
        }
    }

    const verifyButtonText = (link) => {
        if (link.includes("verifyaccount")) {
            return "Verify Now";
        } else if (link.includes("propertylist") || link.includes("properties")) {
            return "View Properties";
        } else if (link.includes("chats")) {
            return "View Chats";
        }
    };

    const filterNotifications = () => {
        if (selectedTab === "All") {
            return notificationsDAta;
        } else if (selectedTab === "Unread") {
            return notificationsDAta.filter((item) => !item.is_read);
        } else if (selectedTab === "Read") {
            return notificationsDAta.filter((item) => item.is_read);
        }
    };

    const onRemove = async (item) => {
        try {
            const url = `/notifications/user/notifications/${item.id}`;
            const response = await deleteApi(url);
            if (response) {
                toast.success("Notification removed successfully", { toastId: "notification_removed" });
                getNotificationData();
            }
        } catch (error) {
            console.log("Error fetching notifications:", error);
        }
    };

    const markAsRead = async (item) => {
        try {
            let url = `/notifications/user/notifications/${item.id}/mark-read`;
            const response = await postApi(url);
            if (response) {
                getNotificationData();
            }
        } catch (error) {
            console.log("Error fetching notifications:", error);
        }
    };
    const renderIcon = (type) => {
        switch (type) {
            case "service_request":
                return <MdSupportAgent />;
            case "property_listing_submission":
                return <TbHomeUp />;
            case "property_update":
            case "package_purchase":
                return <FaCheck />;
            case "property_report_submitted":
                return <MdOutlineReportProblem />;
            default:
                return <TfiEmail />;
        }
    };
    return (
        <div className="tw-fixed tw-text-black tw-p-5 tw-overflow-y-auto tw-h-[calc(100vh-55px)] tw-right-0 tw-top-[55px]  tw-shadow-lg tw-w-full md:tw-w-[500px] xl:tw-w-[600px] 2xl:tw-w-[700px]  tw-bg-white tw-z-[1200]">
            <div className="tw-flex tw-justify-between tw-items-center">
                <p className="tw-text-[20px] tw-text-black tw-font-[600px]">Notifications</p>
                <button
                    onClick={() => setIsNotificationPopupOpen(false)}
                    className="tw-bg-[#F5F7FA] tw-rounded-full tw-h-[35px] tw-w-[35px] tw-flex tw-justify-center tw-items-center"
                >
                    <RxCross2 color="black" />
                </button>
            </div>
            <div className="tw-mt-4 tw-flex tw-gap-5 tw-items-center">
                {["All", "Unread", "Read"].map((item, index) => (
                    <button
                        key={index}
                        className={`tw-p-2 tw-rounded-full hover:tw-bg-background_color tw-px-4 ${
                            item === selectedTab ? "tw-bg-[#F0FDF9] tw-text-primary" : "tw-bg-[#F7F7F7] tw-text-[#767676] "
                        }`}
                        onClick={() => {
                            setSelectedTab(item);
                        }}
                    >
                        {item}
                    </button>
                ))}
            </div>
            <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-3">
                {filterNotifications().map((item, index) => (
                    <div key={index} className="tw-border tw-border-[#D0D5DD] tw-rounded-[10px] tw-w-full tw-p-2 tw-flex tw-gap-2">
                        <div className="tw-border tw-border-[#D0D5DD] tw-rounded-full tw-h-[35px] tw-w-[35px] tw-flex tw-items-center tw-justify-center">
                            {renderIcon(item.type)}
                        </div>
                        <div className="tw-w-full">
                            <div onClick={() => markAsRead(item)} className="tw-flex tw-justify-between tw-w-full tw-items-center">
                                <p className="tw-font-[600] tw-text-black">{item.title}</p>
                                <p className="tw-text-black tw-text-[8px]">{formatDate(item.created_at)}</p>
                            </div>
                            <div className="tw-flex tw-justify-between tw-w-full tw-gap-5">
                                <p className="tw-text-black tw-text-[11px] ">
                                    {item.message}{" "}
                                    {(item?.metadata?.link || item.type === "message") && (
                                        <span onClick={() => onClickItem(item.metadata.link, item)} className="tw-text-primary tw-cursor-pointer">
                                            {item.metadata.link ? verifyButtonText(item.metadata.link) : "View Chats"}
                                        </span>
                                    )}
                                </p>
                                <div>
                                    <RxCross2 onClick={() => onRemove(item)} className="tw-cursor-pointer" />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
